import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, X, ArrowRight } from 'lucide-react';

const STORAGE_KEY = 'klarvi_upsell_minimized';

export function UpsellBanner() {
  const navigate = useNavigate();
  const [minimized, setMinimized] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, minimized.toString());
  }, [minimized]);

  const goToPricing = () => navigate('/precios');

  if (minimized) {
    return (
      <button
        onClick={goToPricing}
        onContextMenu={(e) => {
          e.preventDefault();
          setMinimized(false);
        }}
        className="fixed bottom-4 right-4 z-50 flex items-center gap-2 bg-[#0F172A] text-white pl-3 pr-4 py-2.5 rounded-full shadow-lg hover:bg-[#1E293B] transition-all duration-200 group"
        data-testid="upsell-pill"
        title="Desbloquear Klarvi Pro"
      >
        <Zap className="w-4 h-4 text-amber-400 fill-amber-400" />
        <span className="text-sm font-medium">Desbloquear Pro</span>
      </button>
    );
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#0F172A] text-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)]" data-testid="upsell-banner">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <Zap className="w-4 h-4 text-amber-400 fill-amber-400 flex-shrink-0" />
          <p className="text-sm truncate">
            <span className="hidden sm:inline">Estas usando la version gratuita de Klarvi. </span>
            <span className="font-medium">Da clic para desbloquear todo sin limites</span>
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={goToPricing}
            className="flex items-center gap-1.5 bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-medium px-4 py-1.5 rounded-full transition-colors"
            data-testid="upsell-cta"
          >
            Ver planes
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
          <button
            onClick={() => setMinimized(true)}
            className="p-1.5 rounded-full hover:bg-white/10 transition-colors"
            data-testid="upsell-minimize"
            title="Minimizar"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
